import { ActivateTrialMembershipModal } from 'src/components/ActivateTrialMembershipModal/activate-trial-membership-modal';
import { AddClientModal } from 'src/components/AddClientModal/add-client-modal';
import { AddComplimentaryPeriodModal } from 'src/components/AddComplimentaryPeriodModal/add-complimentary-period-modal';
import { AddConversationModal } from 'src/components/AddConversationModal/add-conversation-modal';
import { AddPartnerDomainModal } from 'src/components/AddPartnerDomainModal/add-partner-domain-modal';
import { AddPreSoldMembershipModal } from 'src/components/AddPreSoldMembershipModal/add-pre-sold-membership-modal';
import { AddProjectModal } from 'src/components/AddProjectModal/add-project-modal';
import { AddressFileRenameModal } from 'src/components/AddressFileRenameModal/address-file-rename-modal';
import { AddSiteModal } from 'src/components/AddSiteModal/add-site-modal';
import { SupportPolicyModal } from 'src/components/Assistant/policies-tab/policy-modal';
import { ClientSegmentAddModal } from 'src/components/ClientSegmentModals/client-segment-add-modal';
import { ClientSegmentEditModal } from 'src/components/ClientSegmentModals/client-segment-edit-modal';
import { ContactSupportModal } from 'src/components/ContactSupportModal/contact-support-modal';
import { CopyTextModal } from 'src/components/CopyTextModal/copy-text-modal';
import { CreatePartnerModal } from 'src/components/CreatePartnerModal/create-partner-modal';
import { CreateUserModal } from 'src/components/CreateUserModal/create-user-modal';
import { CustomSignupLinkModal } from 'src/components/CustomSignupLinkModal/custom-signup-link-modal';
import { ImportDtoolsProjectModal } from 'src/components/ImportDtoolsProjectModal/import-dtools-project-modal';
import { ImportPortalioProjectModal } from 'src/components/ImportPortalioProjectModal/import-portalio-project-modal';
import { ImportProposalsModal } from 'src/components/ImportProposalsModal/import-proposals-modal';
import { MemberServicesFollowUpModal } from 'src/components/MemberServicesFollowUpModal/member-services-followup-modal';
import { AssociateParticipantWithClientModal } from 'src/components/MergeClientModal/associate-participant-with-client-modal';
import { MergeClientModal } from 'src/components/MergeClientModal/merge-client-modal';
import { MergeConversationModal } from 'src/components/MergeConversationModal/merge-conversation-modal';
import { MergeSiteModal } from 'src/components/MergeSiteModal/merge-site-modal';
import { SelectPartnerModal } from 'src/components/Navbar/select-partner-dialog';
import { PauseSubscriptionModal } from 'src/components/PauseSubscriptionModal/pause-subscription-modal';
import { ProposalLostModal } from 'src/components/ProposalLostModal/proposal-lost-modal';
import { ProposalWonModal } from 'src/components/ProposalWonModal/proposal-won-modal';
import { PublicApiKeyModal } from 'src/components/PublicApiKeyModal/public-api-key-modal';
import { QuickActionsModal } from 'src/components/QuickActions/quick-actions-modal';
import { ResentInviteWithPasswordModal } from 'src/components/ResendInviteWithPasswordModal/resend-invite-with-password-modal';
import { ScheduleHolidayModal } from 'src/components/ScheduleHolidayModal/schedule-holiday-modal';
import { SendMembershipEmailModal } from 'src/components/SendMembershipEmailModal/send-membership-email-modal';
import { ShortcutsModal } from 'src/components/ShortcutsModal/shortcuts-modal';
import { SnoozeConversationModal } from 'src/components/SnoozeConversationModal/snooze-conversation-modal';
import { SubmitDay1Modal } from 'src/components/SubmitDay1Modal/submit-day1-modal';
import { UpdateClientToAddressModal } from 'src/components/UpdateClientToAddressModal/update-client-to-address-modal';
import { UpdateConversationToAddressModal } from 'src/components/UpdateConversationToAddressModal/update-conversation-to-address-modal';
import { UpdateUserAssigneeGroupsModal } from 'src/components/UpdateUserAssigneeGroups/update-user-assignee-groups-modal';
import { UpdateUserModal } from 'src/components/UpdateUserModal/update-user-modal';
import { UpdateUserPermissionsModal } from 'src/components/UpdateUserPermissionsModal/update-user-permissions-modal';
import { UserSearchModal } from 'src/components/UserSearchModal/user-search-modal';
import { AiPromptModal } from 'src/pages/Conversations/Chat/AiAssistant/ai-prompts-modal';
import { MacrosModal } from 'src/pages/Conversations/Chat/Macros/macros-modal';
import { AddCustomAttributeModal } from 'src/pages/Settings/custom-attributes/add-custom-attribute-modal';
import { ManageCustomAttributeGroupModal } from 'src/pages/Settings/custom-attributes/manage-custom-attribute-group-modal';
import { AddCgCustomDomainModal } from 'src/pages/Settings/memberships/custom-domain/add-cg-custom-domain-modal';
import { SignalOnCallScheduleModal } from 'src/pages/Settings/signal-oncall-schedule/signal-oncall-schedule-modal';
import { ManageAssigneeGroupModal } from 'src/pages/Settings/users/assignee-groups/manage-assignee-group-modal';
import { NewWorkflowModal } from 'src/pages/Settings/workflows/components/new-workflow-modal';
import { WorkflowAssignmentsModal } from 'src/pages/Settings/workflows/components/workflow-assignments-modal';
import { Modals } from './modals';

/**
 * The modal id -> component map, kept out of `./modals` on purpose: that module
 * exports the `Modals` enum and the `useModalMethods`/`useShowModals` hooks that
 * half the app imports, and pulling the 48 component modules in with them made
 * every such importer own the whole app's dependency graph.
 */
export const ModalComponents = {
  [Modals.AddComplimentaryPeriod]: AddComplimentaryPeriodModal,
  [Modals.ActivateTrialMembership]: ActivateTrialMembershipModal,
  [Modals.AddConversationModal]: AddConversationModal,
  [Modals.AddClientModal]: AddClientModal,
  [Modals.AddPartnerDomainModal]: AddPartnerDomainModal,
  [Modals.CreatePartnerModal]: CreatePartnerModal,
  [Modals.AddPreSoldMembership]: AddPreSoldMembershipModal,
  [Modals.AddProject]: AddProjectModal,
  [Modals.AddSiteModal]: AddSiteModal,
  [Modals.AssociateParticipantWithClientModal]: AssociateParticipantWithClientModal,
  [Modals.UpdateClientToAddress]: UpdateClientToAddressModal,
  [Modals.ContactSupportModal]: ContactSupportModal,
  [Modals.CreateUser]: CreateUserModal,
  [Modals.MemberServicesFollowUp]: MemberServicesFollowUpModal,
  [Modals.MergeClientModal]: MergeClientModal,
  [Modals.MergeConversationModal]: MergeConversationModal,
  [Modals.MergeSiteModal]: MergeSiteModal,
  [Modals.ProposalLost]: ProposalLostModal,
  [Modals.ProposalWon]: ProposalWonModal,
  [Modals.ResentInviteWithPassword]: ResentInviteWithPasswordModal,
  [Modals.ScheduleHolidays]: ScheduleHolidayModal,
  [Modals.SendMembershipEmail]: SendMembershipEmailModal,
  [Modals.SnoozeConversationModal]: SnoozeConversationModal,
  [Modals.SubmitDay1]: SubmitDay1Modal,
  [Modals.UpdateAssigneeGroups]: UpdateUserAssigneeGroupsModal,
  [Modals.UpdateUser]: UpdateUserModal,
  [Modals.UpdateUserPermissions]: UpdateUserPermissionsModal,
  [Modals.QuickActionsModal]: QuickActionsModal,
  [Modals.MacrosModal]: MacrosModal,
  [Modals.UserSearchModal]: UserSearchModal,
  [Modals.AddCustomAttributeModal]: AddCustomAttributeModal,
  [Modals.ManageCustomAttributGroupModal]: ManageCustomAttributeGroupModal,
  [Modals.UpdateConversationToAddress]: UpdateConversationToAddressModal,
  [Modals.AiPrompts]: AiPromptModal,
  [Modals.ShortcutsModal]: ShortcutsModal,
  [Modals.SelectPartnerModal]: SelectPartnerModal,
  [Modals.AddressFileRename]: AddressFileRenameModal,
  [Modals.AddCgCustomDomain]: AddCgCustomDomainModal,
  [Modals.SignalOnCallScheduleModal]: SignalOnCallScheduleModal,
  [Modals.SupportPolicyModal]: SupportPolicyModal,
  [Modals.CopyText]: CopyTextModal,
  [Modals.CustomSignupLink]: CustomSignupLinkModal,
  [Modals.PauseSubscription]: PauseSubscriptionModal,
  [Modals.ImportProposals]: ImportProposalsModal,
  [Modals.ImportDtoolsProjects]: ImportDtoolsProjectModal,
  [Modals.WorkflowAssignments]: WorkflowAssignmentsModal,
  [Modals.NewWorkflow]: NewWorkflowModal,
  [Modals.ImportPortalioProjects]: ImportPortalioProjectModal,
  [Modals.ClientSegmentAddModal]: ClientSegmentAddModal,
  [Modals.ClientSegmentEditModal]: ClientSegmentEditModal,
  [Modals.ManageAssigneeGroup]: ManageAssigneeGroupModal,
  [Modals.PublicApiKey]: PublicApiKeyModal,
};
